// Validation on submit
export const firstNameValidation = (firstName) => {
  const nameRegex = "^[a-zA-Z]{2}[a-zA-Z '0-9]{0,28}$"
  if (firstName.match(nameRegex)) {
    return true
  } else {
    return false
  }
}
export const emailValidation = (email) => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  // const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  if (email.match(emailRegex)) {
    return true
  } else {
    return false
  }
}

export const numberValidation = (number) => {
  if (!isNaN(Number(number))) {
    return true
  } else {
    return false
  }
}

export const phoneValidation = (number) => {
  if (!isNaN(Number(number)) && number?.length === 10) {
    return true
  } else {
    return false
  }
}

export const noSpaceValidation = (input) => {
  if (!input.includes(' ')) {
    return true
  } else {
    return false
  }
}

export const notEmptyValidation = (input) => {
  if (input.length > 0) {
    return true
  } else {
    return false
  }
}

export const urlValidation = (url) => {
  var urlRegex =
    // eslint-disable-next-line no-useless-escape
    /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/gm

  if (url.match(urlRegex)) {
    return true
  } else {
    return false
  }
}

export const passwordValidation = (password) => {
  const lowerCaseLetters = /[a-z]/g
  const upperCaseLetters = /[A-Z]/g
  const numbers = /[0-9]/g
  var regularExpression = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,16}$/

  if (
    password.match(lowerCaseLetters) &&
    password.match(upperCaseLetters) &&
    password.match(numbers) &&
    password.length >= 8 &&
    password.match(regularExpression)
  ) {
    return true
  } else {
    return false
  }
}

export const confirmPasswordValidation = (password, confirm) => {
  if (password === confirm) {
    return true
  } else {
    return false
  }
}
export const websiteValidation = (website) => {
  if (!website || urlValidation(website)) {
    return true
  } else {
    return false
  }
}

export const maxLengthValidation = (text, max) => {
  if (text.length <= max) {
    return true
  } else {
    return false
  }
}

export const minLengthValidation = (text, max) => {
  if (text.length >= max) {
    return true
  } else {
    return false
  }
}

// Validation on input change

export const phoneOnChange = (phone) => {
  if (
    numberValidation(phone) &&
    phone.length <= 10 &&
    noSpaceValidation(phone)
  ) {
    return true
  } else {
    return false
  }
}

export const noSpaceOnChange = (input) => {
  if (!input.includes(' ')) {
    return true
  } else {
    return false
  }
}

export const numberOnChange = (number) => {
  if (!isNaN(Number(number))) {
    return true
  } else {
    return false
  }
}

export const maxLengthOnChange = (text, max) => {
  if (text.length <= max) {
    return true
  } else {
    return false
  }
}

export const minLengthOnChange = (text, min) => {
  if (text.length >= min) {
    return true
  } else {
    return false
  }
}

export  function formatTimeCommon(seconds) {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;

  if (minutes === 0) {
    return `${remainingSeconds} seconds`
  } else if (remainingSeconds === 0) {
    return `${minutes} minute`;
  } else {
    return ` ${minutes} minute and ${remainingSeconds} seconds`;
  }
}


export const formatDateCommon = (timestamp) => {
  const date = new Date(timestamp * 1000); // Convert Unix timestamp to milliseconds

  // Define month names
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  // Format date
  const day = date.getDate();
  const month = months[date.getMonth()];
  const year = date.getFullYear();

  return `${day} ${month} ${year}`;
};

export const formatCentsToDollars = (amountInCents) => {
  return `${(amountInCents / 100).toFixed(2)}$`;
};
export  function localTimeCommonFunction() {
  const now = new Date();

  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are zero-based, so add 1
  const day = String(now.getDate()).padStart(2, '0');
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  const seconds = String(now.getSeconds()).padStart(2, '0');

  // Combine into an ISO-like string in local time
  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
}